import { addItemsToCart } from '@/js/cart-utils';
import DynamicSection from '../dynamic-section/dynamic-section';
import { updateFreshpackText, updatePrice } from '@/js/product-card-helpers';

class ProductCard extends DynamicSection {
  connectedCallback() {
    this.initVariables();
    this.initEventListeners();
    updateFreshpackText(this, 1);
  }

  initVariables() {
    this.formElement = this.querySelector('form');
    const quantityInput = this.querySelector('[data-quantity-input]');

    if (!quantityInput) return;

    this.quantity = quantityInput
      ? Math.max(1, Number.parseInt(quantityInput.getAttribute('min')) || 1)
      : 1;
    this.button = this.querySelector('[data-add-to-cart]');
    this.quickAddButton = this.querySelector('[data-quick-add]');
    this.quickAddClose = this.querySelector('[data-quick-add-close]');
    this.productPriceElements = this.querySelectorAll('[data-product-price]');
    this.maxQuantity = quantityInput.getAttribute('max');
    if (quantityInput) {
      quantityInput.addEventListener(
        'input',
        this.preventInvalidQuantity.bind(this)
      );
    }
  }

  /**
   * Prevents invalid quantity input
   * @param {event} event - input event
   * @returns {void}
   */
  preventInvalidQuantity(event) {
    const input = event.target;
    let value = input.value;

    value = value.replaceAll(/[^0-9]/g, '');
    value = Math.max(1, Number.parseInt(value, 10) || 1);
    value = Math.max(
      0,
      Math.min(this.maxQuantity, Number.parseInt(value, 10) || 0)
    );

    input.value = value;
  }

  initEventListeners() {
    if (!this.formElement) return;
    /* Add to cart */
    this.formElement?.addEventListener('submit', event => {
      event.preventDefault();

      const form = event.target;
      const formData = new FormData(form);
      addItemsToCart(formData, this.button);
    });

    this.quickAddButton?.addEventListener('click', event => {
      event.preventDefault();
      if (!this.quickAddButton) return;

      const productCard = this.quickAddButton.closest('product-card');
      productCard.dataset.flipped = 'true';
    });

    this.quickAddClose?.addEventListener('click', event => {
      event.preventDefault();
      if (!this.quickAddClose) return;

      const productCard = this.quickAddClose.closest('product-card');
      productCard.dataset.flipped = 'false';
    });

    this.addEventListener('pxl:quantityChange', event => {
      updatePrice(event.detail.quantity, this.productPriceElements);
      updateFreshpackText(this, event.detail.quantity);
      this.quantity = event.detail.quantity;
    });
  }
}

customElements.get('product-card') ||
  customElements.define('product-card', ProductCard);
